var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.4422 7.05849C21.9629 7.57919 21.9629 8.42341 21.4422 8.94411L14.385 16.0013L21.4422 23.0585C21.9629 23.5792 21.9629 24.4234 21.4422 24.9441C20.9215 25.4648 20.0772 25.4648 19.5565 24.9441L11.5565 16.9441C11.0358 16.4234 11.0358 15.5792 11.5565 15.0585L19.5565 7.05849C20.0772 6.53779 20.9215 6.53779 21.4422 7.05849Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjQ0MjIgNy4wNTg0OUMyMS45NjI5IDcuNTc5MTkgMjEuOTYyOSA4LjQyMzQxIDIxLjQ0MjIgOC45NDQxMUwxNC4zODUgMTYuMDAxM0wyMS40NDIyIDIzLjA1ODVDMjEuOTYyOSAyMy41NzkyIDIxLjk2MjkgMjQuNDIzNCAyMS40NDIyIDI0Ljk0NDFDMjAuOTIxNSAyNS40NjQ4IDIwLjA3NzIgMjUuNDY0OCAxOS41NTY1IDI0Ljk0NDFMMTEuNTU2NSAxNi45NDQxQzExLjAzNTggMTYuNDIzNCAxMS4wMzU4IDE1LjU3OTIgMTEuNTU2NSAxNS4wNTg1TDE5LjU1NjUgNy4wNTg0OUMyMC4wNzcyIDYuNTM3NzkgMjAuOTIxNSA2LjUzNzc5IDIxLjQ0MjIgNy4wNTg0OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";